import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const allSecretManagers = newSecretManagerElement({
  owner: "ServiceNow instance",
  connector: "ServiceNow",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

/** The instance name: the first label of `<name>.service-now.com`. It is also
 * part of GCP secret ids. */
export const SERVICENOW_INSTANCE_PATTERN = /^[a-z0-9-]+$/;

export const ServiceNowAiComponents = InstallSpec({
  instance: ItemComponent({
    type: "string",
    label: "ServiceNow instance",
    description:
      "An instance where P0 creates a ServiceNow machine user for each agent session (the name in <name>.service-now.com)",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      SERVICENOW_INSTANCE_PATTERN.test(id)
        ? undefined
        : "Use only lowercase letters, digits and hyphens",
    schema: {
      secretManager,
      provisionerClientId: Element({
        type: "string",
        label: "Provisioner client ID",
        description:
          "Client ID of the client credential integration whose OAuth application user has only user_admin",
      }),
      jwtClientId: Element({
        type: "string",
        label: "JWT bearer client ID",
        description:
          "Client ID of the JWT bearer integration that trusts the connector's signing certificate",
      }),
      keyId: Element({
        type: "string",
        label: "Signing key ID",
        description:
          "The kid of the signing certificate in the JWT bearer integration's verifier map",
      }),
    },
  }),
});

export type ServiceNowAiComponents = typeof ServiceNowAiComponents;
